import React, { useEffect } from "react";
import logoImage from './logo.png';
import girlImage from './girl.png';
import winImage from './win.png';
import mobileShopImage from './mobile-shop.png';
import mobileNotifImage from './mobile-notif.png';
import zipperticLogo from './ziplogo.png';
import { useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import useJumbotron, { MODE_DRAW, MODE_PREDRAW } from "./useJumbotron";
import Loading from "components/Loading";
import numeral from "numeral";
import i18n from "i18n";
import './styles.scss';

const price = amount => amount ? `${numeral(amount).format('0,0')} kr` : '';

function itemIds(arr) {
  if (arr.length === 0) {
    return "";
  }
  if (arr.length === 1) {
    return String(arr[0]); // Returns the single element as a string
  }
  // For two or more elements, join them with a comma and space
  return arr.join(', ');
}

const Jumbotron = () => {

    const { id } = useParams();

    const { price_pool, items, mode, ready, price_amount_raw } = useJumbotron({eventId: id});

    const [t] = useTranslation();
    numeral.locale('se');

    const { language } = i18n;
    useEffect(() => {
        if (language !== 'se') {
            i18n.changeLanguage('se');
            return;
        }
    }, [language]);


    if (!ready) {
        return <Loading />;
    }

    return (
    <div className={`jbzt-sk-body ${mode === MODE_DRAW ? '' : ''}`}>
        <div className="jbzt-box">
            <div className="jbzt-container">            
                <img className="jbzt-sk-logo" src={logoImage} alt="Skuru Logo" />
                
                {mode === MODE_PREDRAW && <img className="jbzt-sk-girl" src={girlImage} />}
                {mode === MODE_DRAW && <img className="jbzt-sk-win" src={winImage} />}

                {mode === MODE_PREDRAW && <img className="jbzt-sk-mobile-shop" src={mobileShopImage} />}
                {mode === MODE_DRAW && <img className="jbzt-sk-mobile-shop" src={mobileNotifImage} />}

                <div className="jbzt-header">
                    <h1 className="bold">Köp 50/50-lotter i<img className="jbzt-zp-logo" src={zipperticLogo} alt="ZipperTic Logo" /></h1>
                </div>
                <div className="jbzt-content">
                    {mode === MODE_PREDRAW && <p className="ztjb-text">Vinstpott: {price(price_pool)}</p>}
                    {mode === MODE_DRAW && <p className="ztjb-text">Vinstlott: {itemIds(items)}<br/>
                    <h4>Vinstsumma: {price(price_amount_raw)}</h4></p>}
                </div>
            </div>
        </div>
    </div>
    );
};

export const path = '/jumbotron/:id';
Jumbotron.path = path;
export default Jumbotron;
